import { render, staticRenderFns } from "./best-price-countdown.vue?vue&type=template&id=4791baae&scoped=true"
import script from "./best-price-countdown.vue?vue&type=script&lang=ts"
export * from "./best-price-countdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4791baae",
  null
  
)

export default component.exports